





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
@Component
export default class ReferralIncentive extends Vue {
  @Prop() variableAmount;
  @Prop() fixedAmount;
  @Prop() incentiveQuantityUOM;
  @Prop() variableIncentiveEnabled;
  get total() {
    return this.variableAmount + this.fixedAmount;
  }
}
